import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import SubHeader from "../../components/SubHeader";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import AllRecivedInquiry from "./AllRecivedInquiry";
import AllSendInquiry from "./AllSendInquiry";
import { useAuth } from "../../AuthProvider";
import { MENU_ROUTES } from "../../config/menuRoutes";
import AllAdminInquiry from "./AllAdminInquiry";
import { atob } from "js-base64";

const AllInquiries = (props) => {

  const initialRef = useRef(true);
  const nav = useNavigate();
  const { isEndUser, isSuperAdmin, isDemoUser, user, isViewer, isInqUser } = useAuth();
  const [fdate, setFdate] = useState(null);
  const [cKey, setCkey] = useState(0);

  useEffect(() => {
    if (isEndUser) {
      nav(MENU_ROUTES.MY_INQUIRIES);
    }
  }, [isEndUser, user]);

  const { fordate } = useParams();

  useEffect(() => {
    if (isEndUser) {
      nav(MENU_ROUTES.MY_INQUIRIES);
    }
  }, [isEndUser, user]);

  useEffect(() => {
    if (fordate !== undefined) {
      let fdate = atob(fordate);
      console.log("fdate ============== ", fdate)
      setFdate(fdate);
      setCkey((prev) => prev + 1);
    } else {
      setFdate(null);
      setCkey((prev) => prev + 1);
    }
  }, [fordate]);

  return (
    <div className="data-table-main" key={cKey}>
      <SubHeader
        layer1="All Inquiries"
        layer2=""
        layer3="List"
        pageName="All Inquiries"
        clickable={{
          layer1: "",
          layer2: "",
          layer3: "",
        }}
      />

      <div className="send-receive-inquiry">
        {!isSuperAdmin && !isViewer && !isInqUser && (isDemoUser && (fdate !== 'week' && fdate !== 'this_month' && fdate !== 'last_month')) && (

          <Tab.Container id="left-tabs-example" defaultActiveKey="Received Inquiry">
            <Row>
              <Col sm={12} className="tab-menu">
                <div className="tab-menu-child">
                  <Nav variant="pills">
                    <Nav.Item>
                      <Nav.Link eventKey="Sent Inquiry" className="d-flex">
                        <p className="px-2 profile-tab ">Sent Inquiry</p>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="Received Inquiry" className="d-flex">
                        <p className="px-2 profile-tab">Received Inquiry</p>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </Col>

              <Col sm={12}>
                <Tab.Content>
                  <Tab.Pane eventKey="Sent Inquiry">
                    <AllSendInquiry type="SEND" />
                  </Tab.Pane>

                  <Tab.Pane eventKey="Received Inquiry">
                    <AllRecivedInquiry type="RECEIVED" />
                  </Tab.Pane>

                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        )}

        {((isSuperAdmin || isViewer || isInqUser || (isDemoUser && (fdate === 'week' || fdate === 'this_month' || fdate === 'last_month'))) && (
          <AllAdminInquiry fordate={fordate} />
        ))}

      </div>

    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AllInquiries);
